module.exports = __webpack_public_path__ + "media/img/decorations/our-services-img-5f37a3e0b560e76942883f1422409276.svg";